import roundPenceConsistently from './roundPenceConsistently';

interface Plan {
  OnOffPlatform: string;
  PlanValueInAcctCcy: number | string;
}

interface PlanOwner {
  Plans: Plan[];
}

interface PlanOwnerTotals {
  SaltusPlatforms: number;
  OtherPlatforms: number;
  TotalPortfolioWealth: number;
}

const calcPlanOwnerTotals = (
  planOwner: PlanOwner | null | undefined,
): PlanOwnerTotals => {
  const totals: PlanOwnerTotals = {
    SaltusPlatforms: 0,
    OtherPlatforms: 0,
    TotalPortfolioWealth: 0,
  };

  if (planOwner) {
    planOwner.Plans.forEach((plan) => {
      const value = roundPenceConsistently(plan.PlanValueInAcctCcy);
      if (plan.OnOffPlatform === 'On Platform') {
        totals.SaltusPlatforms += value;
      } else {
        totals.OtherPlatforms += value;
      }
      totals.TotalPortfolioWealth += value;
    });
  }

  return totals;
};

export type { PlanOwner, PlanOwnerTotals };
export default calcPlanOwnerTotals;
